import React from 'react';
import './ProblemSolution.css';

const ProblemSolution: React.FC = () => {
  return (
    <section className="problem-solution-section">
      <h2>The Problem</h2>
      <p>Managing tasks and ensuring quality across multiple locations or teams can be challenging. Inconsistent processes lead to errors, customer dissatisfaction, and operational inefficiencies. Traditional checklists are static and lack the intelligence to adapt to real-time needs.</p>
      <h2>Our Solution</h2>
      <p>CheckifAI offers dynamic, AI-driven checklists that adapt to your business needs. Our platform provides real-time insights, automates task management, and ensures consistent quality across all operations. With CheckifAI, you can streamline workflows, reduce errors, and enhance customer satisfaction.</p>
    </section>
  );
};

export default ProblemSolution;
